module.exports = __webpack_public_path__ + "img/FEAMP_1.0fe4d75d.webp";